export function degreeToRadian(degree: number): number {
  return degree * 0.017453;
}

export function radianToDegree(radian: number): number {
  return radian * 57.29578;
}

export function metersToInches(meters: number): number {
  return meters * 39.3701;
}

export function inchesToMeters(inches: number): number {
  return inches / 39.3701;
}
